<form [formGroup]="form">
  <div class="flex items-start gap-4">
    <pr-practice-selector
      class="flex-1"
      [brands]="brands$ | async"
      [practice]="selectedPractice$ | async"
      (practiceSelected)="selectedPractice$.next($event)"
    />

    <mat-form-field class="flex-1">
      <mat-label>Phone Number</mat-label>
      <input matInput formControlName="phoneNumber" />
      <mat-hint align="end">
        Must have international prefix (e.g. +61 for AU)
      </mat-hint>
    </mat-form-field>

    <div matTextSuffix (click)="$event.stopImmediatePropagation()">
      <ng-content />
    </div>
  </div>
</form>
